import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { Outlet } from 'react-router-dom';

const AdminDashboard: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const role = user?.role;

  if (role !== 'admin' && role !== 'superadmin') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="card text-center max-w-md">
          <div className="w-16 h-16 rounded-full bg-red-50 text-red-500 flex items-center justify-center mx-auto mb-4">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </div>
          <h3 className="font-display font-bold text-xl text-trident-gray-900 mb-2">Access Denied</h3>
          <p className="text-trident-gray-500 text-sm">You must be an administrator to view this page.</p>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default AdminDashboard;
